import { useQuery, useMutation, useQueryClient } from "react-query";
import { getSurvey, getSurveys } from "./queryKey";
import axiosLib from "../../axiosLib";
import { API_URL } from "../../config";

export const getSurveyRequest = async (userId) => {
  if (!userId) return null;

  try {
    const response = await axiosLib.get(`${API_URL}/survey/${userId}`);
    if (response.data.success) {
      const surveys = response.data.surveys ?? [];
      if (surveys.length > 0) {
        return surveys.find((item) => item.isMain) || surveys[0];
      }
    }
    return null;
  } catch (error) {
    console.error("Error fetching survey:", error);
    return null;
  }
};

export const useGetSurvey = (userId) => {
  return useQuery(getSurvey(userId), async () => getSurveyRequest(userId), {
    enabled: !!userId,
    retry: 1,
    retryDelay: 1000,
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    refetchOnReconnect: false,
    // Clear cache when component unmounts
    keepPreviousData: false,
  });
};

export const getSurveysRequest = async (userId) => {
  if (!userId) return [];

  try {
    const response = await axiosLib.get(`${API_URL}/survey/${userId}`);
    if (response.data.success) {
      return response.data.surveys ?? [];
    }
    return [];
  } catch (error) {
    console.error("Error fetching surveys:", error);
    return [];
  }
};

export const useGetSurveys = (userId) => {
  return useQuery(getSurveys(userId), async () => getSurveysRequest(userId), {
    enabled: !!userId,
    retry: 1,
    retryDelay: 1000,
    staleTime: 60 * 1000,
    cacheTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    refetchOnReconnect: false,
    keepPreviousData: true,
  });
};

export const setMainSurveyRequest = async (surveyId) => {
  if (!surveyId) return null;

  const response = await axiosLib.put(`${API_URL}/survey/${surveyId}/main`);
  return response.data;
};

export const useSetMainSurvey = (userId) => {
  const queryClient = useQueryClient();

  return useMutation(
    async (surveyId) => setMainSurveyRequest(surveyId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(getSurveys(userId));
        queryClient.invalidateQueries(getSurvey(userId));
      },
    }
  );
};